import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Toolbar from 'components/common/Toolbar';
import ToolbarFooter from 'components/common/Toolbar/ToolbarFooter';
import getAllGroups from 'redux/actions/groups/getAllGroups';
import GroupWalletTable from 'components/Wallet/GroupWalletTable';
import formatNumber from 'helpers/formatNumber';
import SingleGroupWallet from './SingleGroupWallet';
import './index.scss';

const GroupWallet = ({ props }) => {
  const dispatch = useDispatch();
  const { match } = props || {};
  const groupId = match?.params?.groupId;

  const { items: groups, meta, loading, error } = useSelector(
    ({ groups: { allGroups } }) => allGroups,
  );

  useEffect(() => {
    getAllGroups()(dispatch);
  }, []);

  const onQuery = queries => {
    getAllGroups(queries)(dispatch);
  };

  if (groupId) {
    return <SingleGroupWallet match={match} />;
  }

  return (
    <div className="group-wallet">
      <Toolbar
        header={{
          title: `All Groups Wallets (${formatNumber(
            meta?.total || 0,
          )})`,
          rightComponent: (
            <ToolbarFooter
              onSearch={onQuery}
              onPaginate={onQuery}
              paginationMeta={meta}
              exportCSVData={groups}
              exportCSVFileName="GroupWallets"
              filterTransactions
              onFilterTransactions={onQuery}
              filterTransactionsOptions={['active', 'inactive']}
            />
          ),
        }}
      />

      <div className="scroll-wrapper">
        <GroupWalletTable
          groups={groups}
          loading={loading}
          error={error}
        />
      </div>
    </div>
  );
};

GroupWallet.propTypes = {
  props: PropTypes.shape({
    match: PropTypes.shape({
      params: PropTypes.shape({
        groupId: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default GroupWallet;
